var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
import blockquoteDefaultData from "./../../ricos-schema/legacy/statics/blockquote.defaults.json";
const toParagraphFields = (node) => {
  const { id: paragraphId, paragraphData = {} } = node;
  return { paragraphData, paragraphId };
};
const toParagraphNode = (fields) => (nodes) => {
  return {
    id: fields.paragraphId,
    type: Node_Type.PARAGRAPH,
    paragraphData: fields.paragraphData,
    nodes
  };
};
const blockquoteConverter = {
  toTiptap: {
    types: [Node_Type.BLOCKQUOTE],
    convert: (node, visit) => {
      var _a;
      const { id, style, blockquoteData } = node || {};
      const { paragraphData, paragraphId } = toParagraphFields(node.nodes[0]);
      return {
        type: Node_Type.BLOCKQUOTE,
        attrs: __spreadProps(__spreadValues({
          paragraphId,
          textStyle: paragraphData.textStyle,
          indentation: (_a = blockquoteData == null ? void 0 : blockquoteData.indentation) != null ? _a : blockquoteDefaultData.indentation
        }, style ? { style } : {}), {
          id
        }),
        // skip internal paragraph, go to text nodes
        content: visit(node.nodes[0])
      };
    }
  },
  fromTiptap: {
    types: [Node_Type.BLOCKQUOTE],
    convert: (node, visit) => {
      const { id, style, paragraphId, textStyle, indentation } = node.attrs || {};
      const paragraphNode = toParagraphNode({
        paragraphData: { indentation: 0, textStyle },
        paragraphId
      })(visit(node));
      return __spreadProps(__spreadValues({
        type: Node_Type.BLOCKQUOTE,
        id,
        nodes: [paragraphNode]
      }, style ? { style } : {}), {
        blockquoteData: {
          indentation
        }
      });
    }
  }
};
export {
  blockquoteConverter
};
//# sourceMappingURL=blockquote-converter.js.map
